var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.15.1A1.2 1.2 0 0 0 0 1.37C.17 3.36.76 7.28 2.94 9.8a12.21 12.21 0 0 0 9.88 4.17A1.2 1.2 0 0 0 14 12.8v-2.4a1.2 1.2 0 0 0-.94-1.17L11 8.8a.91.91 0 0 0-.95.37l-.39.59a.6.6 0 0 1-.74.22C7.7 9.43 4.5 7.76 3.96 5.08a.57.57 0 0 1 .24-.62l.59-.36a1.17 1.17 0 0 0 .57-1.22L4.96.93A1.18 1.18 0 0 0 3.74 0L1.15.1Z","fill":"currentColor"}));
}

Phone.defaultProps = {"fill":"none","viewBox":"0 0 14 14"};

module.exports = Phone;

Phone.default = Phone;
